import { render, staticRenderFns } from "./RepliedMessageRow.vue?vue&type=template&id=7fd9541f&scoped=true&"
import script from "./RepliedMessageRow.vue?vue&type=script&lang=js&"
export * from "./RepliedMessageRow.vue?vue&type=script&lang=js&"
import style0 from "./RepliedMessageRow.vue?vue&type=style&index=0&id=7fd9541f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd9541f",
  null
  
)

export default component.exports